import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LoginService } from './../_services/login.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.scss']
})
export class ResetpasswordComponent implements OnInit {
  resetpassword: boolean;
  forgetpassword: boolean;
  forgetpassword_form: FormGroup
  resetpasswordemailid: any;
  userid: string;
  resetpassword_form: FormGroup;
  resetpwsuccess: boolean;
  successMessage: any;
  errorMessage: any;


  constructor(private router : Router , private loginservice : LoginService ,public fb:FormBuilder ,private route :ActivatedRoute) { }

  ngOnInit() { 
    if (this.router.url.includes('forgetpassword')) {
      this.forgetpassword = true
    } else if (this.router.url.includes('resetpassword')){
      this.resetpassword = true
      let url = window.location.href;
      var uri_dec = decodeURIComponent(url);
      var info = uri_dec.split('?');
      var expiry = info[1].toString().split("&t=");
      var InfoExpiry = expiry[1];
      var dataUrl = expiry[0].toString().split('&id=');;
      var candidateInfo = dataUrl[0].toString().split('userid=');
      var candidateid = candidateInfo[1];
      this.userid = candidateid
      var InfoVar = dataUrl[1];
      var key = CryptoJS.enc.Base64.parse("#base64Key#");
      var iv = CryptoJS.enc.Base64.parse("#base64IV#");
      var decodeUrl = decodeURI(InfoVar);
      var enc_email = CryptoJS.AES.decrypt(decodeUrl, key, { iv: iv });
      var emailid = enc_email.toString(CryptoJS.enc.Utf8);
      this.loginservice.checkpasswordlinkvalidity({ passwordresetlink: url }).subscribe((res: any) => {
        if(res && res.status == 'success'){
          if(!res.isValid){
            this.router.navigate(['expiry']);
          }
        }
      })
      this.resetpasswordemailid = emailid
    }

    this.forgetpassword_form = this.fb.group({
      emailid: ['', Validators.compose([Validators.required, Validators.pattern('^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$')])],
    })

    this.resetpassword_form = this.fb.group({
      password: ['', Validators.required],
      confirmpwd: ['', Validators.required]
    })

  }

  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }
  
  reconfirmpwd() {
    if (this.resetpassword_form.value.password == this.resetpassword_form.value.confirmpwd) {
      return this.resetpassword_form['controls'].confirmpwd.setErrors(null)
    } else {
      return this.resetpassword_form['controls'].confirmpwd.setErrors({ 'invalidpwd': true })
    }
  }

  requestlink(){
    let data ={
      "loginemail": this.forgetpassword_form.value.emailid
    }

    this.loginservice.forgetpassword(data).subscribe((res:any)=>{
      if(res.status == 'Mail sent'){
        this.toastmessage("We have sent password reset link to your email address","success")
      }else if(res.message == 'Email id not found'){
        this.toastmessage("Email id not found","error")
      }else{
        this.toastmessage("Email id not found","error")
      }
    })
  }

  resetpwd(){
    if(this.resetpassword_form.valid){
      let data ={
        "loginemail": this.resetpasswordemailid,
        "password": this.resetpassword_form.value.password,
        "userid": this.userid
      }
      this.loginservice.resetpassword(data).subscribe((res:any)=>{
        if(res.status == 'success'){
          this.resetpwsuccess = true;
          this.resetpassword = false;
  
        }else{
          this.toastmessage("Something Went Wrong","error")
        }
      })
    }else{
      this.validateAllFormFields(this.resetpassword_form)
    }
   
  }

    validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
}
